import styled from 'styled-components';

export const SidebarContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;

  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;

export const LogoList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
   @media (max-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const LogoItem = styled.div`
  width: 100%;
  max-width: 110px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const LogoImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 4px;
  background-color: white;
`;
